// [목적] follow 도메인 zod 스키마 — 팔로우 그래프 row 직렬화 + 토글 응답 + 목록 쿼리 BE/FE 공유
// [이유] folio-social-and-profile Spec WC-DTO-USER-02 — follows 복합 PK 직렬화 타입과
//         POST/DELETE /users/me/follow/:target 응답 타입을 FE/BE 공유하여 이중 정의 방지
// [사이드 이팩트] FE ProfilePage 팔로우 버튼 상태(following boolean)와 타깃 followerCount 갱신에 직접 영향
// [수정 시 고려사항] alreadyFollowing — idempotent POST 시 중복 감지. targetFollowerCount 는 실시간 값

import { z } from 'zod';

/**
 * follows 테이블 row 직렬화 — 복합 PK (followerId, followeeId).
 */
export const followSchema = z.object({
  followerId: z.string().uuid(),
  followeeId: z.string().uuid(),
  createdAt: z.string(),
});

/**
 * POST / DELETE /users/me/follow/:targetUserId 응답 data 필드.
 * alreadyFollowing — idempotent POST 시 중복 감지용.
 * targetFollowerCount — 변경 반영 후 팔로우 대상의 follower count.
 */
export const followResponseSchema = z.object({
  following: z.boolean(),
  targetFollowerCount: z.number().int().nonnegative(),
  alreadyFollowing: z.boolean(),
});

/**
 * GET /users/:handle/followers, /users/:handle/following 쿼리 파라미터.
 */
export const followListQuerySchema = z.object({
  cursor: z.string().max(500).optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
});

export type Follow = z.infer<typeof followSchema>;
export type FollowResponse = z.infer<typeof followResponseSchema>;
export type FollowListQuery = z.infer<typeof followListQuerySchema>;
